import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  listFournisseurs,
  deleteFournisseur,
  getFournisseur,
  getFournisseurYears,
} from "../services/api";
import Popup from "./Popup";
import "./SalarieList.css";

const MONTHS = [
  { value: "1", label: "Janvier" },
  { value: "2", label: "Février" },
  { value: "3", label: "Mars" },
  { value: "4", label: "Avril" },
  { value: "5", label: "Mai" },
  { value: "6", label: "Juin" },
  { value: "7", label: "Juillet" },
  { value: "8", label: "Août" },
  { value: "9", label: "Septembre" },
  { value: "10", label: "Octobre" },
  { value: "11", label: "Novembre" },
  { value: "12", label: "Décembre" },
];

const formatMoney = (value) => `${Number(value || 0).toFixed(2)} €`;
const formatDate = (value) => {
  if (!value) return "—";
  const s = String(value);
  return s.includes("T") ? s.split("T")[0] : s.slice(0, 10);
};

const FournisseurList = () => {
  const [fournisseurs, setFournisseurs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deletePopup, setDeletePopup] = useState({
    isOpen: false,
    fournisseur: null,
  });
  const [deleteLoading, setDeleteLoading] = useState(null);
  const [filters, setFilters] = useState({
    name: "",
    chantier: "",
    numBonEnlevement: "",
    filterType: "all",
    date: "",
    month: String(new Date().getMonth() + 1),
    year: String(new Date().getFullYear()),
  });
  const [availableYears, setAvailableYears] = useState([new Date().getFullYear()]);
  const [viewFournisseur, setViewFournisseur] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);
  const [selectedAchat, setSelectedAchat] = useState(null);
  const navigate = useNavigate();

  const loadYears = async () => {
    try {
      const years = await getFournisseurYears();
      if (Array.isArray(years) && years.length) setAvailableYears(years);
    } catch (err) {
      console.error("Error loading fournisseur years:", err);
    }
  };

  const loadFournisseurs = async () => {
    setLoading(true);
    try {
      const params = { name: filters.name, chantier: filters.chantier, numBonEnlevement: filters.numBonEnlevement };
      if (filters.filterType === "day" && filters.date) {
        params.filterType = "day";
        params.date = filters.date;
      } else if (filters.filterType === "month" && filters.month && filters.year) {
        params.filterType = "month";
        params.month = filters.month;
        params.year = filters.year;
      } else if (filters.filterType === "year" && filters.year) {
        params.filterType = "year";
        params.year = filters.year;
      }
      const data = await listFournisseurs(params);
      setFournisseurs(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("FournisseurList - Error loading:", err);
      alert("Erreur lors du chargement des fournisseurs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadYears();
  }, []);

  useEffect(() => {
    const timer = setTimeout(loadFournisseurs, 250);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const resetFilters = () => {
    setFilters({
      name: "",
      chantier: "",
      numBonEnlevement: "",
      filterType: "all",
      date: "",
      month: String(new Date().getMonth() + 1),
      year: String(new Date().getFullYear()),
    });
  };

  const handleDelete = (id) => {
    const fournisseur = fournisseurs.find((f) => f.id === id);
    setDeletePopup({ isOpen: true, fournisseur });
  };

  const confirmDelete = async () => {
    const id = deletePopup.fournisseur?.id;
    if (!id) return;
    setDeleteLoading(id);
    try {
      await deleteFournisseur(id);
      setFournisseurs((prev) => prev.filter((f) => f.id !== id));
      setDeletePopup({ isOpen: false, fournisseur: null });
    } catch (err) {
      alert("Erreur lors de la suppression.");
    } finally {
      setDeleteLoading(null);
    }
  };

  const openView = async (fournisseur) => {
    setViewLoading(true);
    setSelectedAchat(null);
    try {
      const details = await getFournisseur(fournisseur.id);
      setViewFournisseur(details);
    } catch (err) {
      console.error(err);
      alert("Impossible de charger les achats de ce fournisseur.");
    } finally {
      setViewLoading(false);
    }
  };

  const dateFilterActive = filters.filterType !== "all";

  return (
    <div className="salarie-list-container">
      <style>
        {`
          .salarie-list-container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 2rem;
            background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
            min-height: 100vh;
          }
          .fournisseurs-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1.25rem;
            flex-wrap: wrap;
            gap: 1rem;
          }
          .salarie-list-title {
            font-size: 2.25rem;
            font-weight: 700;
            background: linear-gradient(135deg, #1e3a8a, #3b82f6, #8b5cf6);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            margin: 0;
          }
          .add-btn {
            background: linear-gradient(135deg, #3b82f6, #1d4ed8);
            color: white;
            padding: 0.75rem 1.5rem;
            border-radius: 12px;
            text-decoration: none;
            font-weight: 600;
            font-size: 0.95rem;
            box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
            transition: all 0.3s ease;
          }
          .add-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(59, 130, 246, 0.6);
          }
          .fournisseur-filters {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
            gap: 0.75rem;
            background: white;
            padding: 1rem 1.1rem;
            border-radius: 16px;
            margin-bottom: 1.25rem;
            border: 1px solid #e5e7eb;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.06);
          }
          .fournisseur-filters label {
            display: flex;
            flex-direction: column;
            gap: 0.35rem;
            font-size: 0.75rem;
            font-weight: 700;
            letter-spacing: 0.04em;
            text-transform: uppercase;
            color: #667eea;
          }
          .fournisseur-filters input,
          .fournisseur-filters select {
            padding: 0.6rem 0.75rem;
            border: 1px solid #dbe3ef;
            border-radius: 10px;
            font-size: 0.92rem;
            color: #1e293b;
            background: #fff;
          }
          .filter-reset-btn {
            align-self: end;
            height: 42px;
            border: none;
            border-radius: 10px;
            background: #e2e8f0;
            color: #334155;
            font-weight: 700;
            cursor: pointer;
          }
          .fournisseurs-table-wrapper {
            background: white;
            border-radius: 16px;
            overflow: hidden;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
            border: 1px solid #e5e7eb;
          }
          .salarie-list-table {
            width: 100%;
            border-collapse: separate;
            border-spacing: 0;
            font-size: 0.95rem;
          }
          .salarie-list-table thead th {
            background: linear-gradient(135deg, #f8fafc, #e2e8f0);
            color: #1e293b;
            font-weight: 700;
            font-size: 0.8rem;
            text-transform: uppercase;
            letter-spacing: 0.1em;
            padding: 1.25rem 1.5rem;
            text-align: left;
          }
          .salarie-list-table tbody tr:nth-child(even) { background: #fafbfc; }
          .salarie-list-table tbody tr:hover {
            background: linear-gradient(135deg, #f0f9ff, #e0f2fe);
          }
          .salarie-list-table td {
            padding: 1rem 1.5rem;
            color: #334155;
            border-bottom: 1px solid #f1f5f9;
          }
          .fournisseur-name { font-weight: 600; color: #1e293b; }
          .budget-badge {
            background: linear-gradient(135deg, #dcfce7, #bbf7d0);
            color: #166534;
            font-weight: 700;
            padding: 0.5rem 1rem;
            border-radius: 12px;
            display: inline-flex;
            border: 1px solid #86efac;
          }
          .actions-cell { display: flex; gap: 0.6rem; align-items: center; flex-wrap: wrap; }
          .salarie-action-btn {
            padding: 0.5rem 1rem;
            border-radius: 8px;
            font-size: 0.85rem;
            font-weight: 600;
            border: none;
            cursor: pointer;
          }
          .salarie-action-btn.view {
            background: linear-gradient(135deg, #6366f1, #4f46e5);
            color: white;
          }
          .salarie-action-btn.edit {
            background: linear-gradient(135deg, #10b981, #059669);
            color: white;
          }
          .salarie-action-btn.delete {
            background: linear-gradient(135deg, #ef4444, #dc2626);
            color: white;
          }
          .empty-state {
            text-align: center;
            padding: 4rem 2rem;
            background: white;
            border-radius: 16px;
            color: #64748b;
            border: 2px dashed #e2e8f0;
          }
          .fournisseur-modal-overlay {
            position: fixed;
            inset: 0;
            background: rgba(15, 23, 42, 0.45);
            z-index: 10000;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 1rem;
          }
          .fournisseur-modal {
            width: min(980px, 96vw);
            max-height: 92vh;
            overflow: auto;
            background: #fff;
            border-radius: 16px;
            box-shadow: 0 20px 50px rgba(0,0,0,0.2);
          }
          .fournisseur-modal.small { width: min(620px, 96vw); }
          .fournisseur-modal-header {
            display: flex;
            justify-content: space-between;
            gap: 1rem;
            padding: 1.25rem 1.5rem;
            border-bottom: 1px solid #e2e8f0;
            background: linear-gradient(135deg, #eef2ff, #f8fafc);
          }
          .fournisseur-modal-header h3 { margin: 0 0 0.3rem; color: #1e3a8a; }
          .fournisseur-modal-close {
            border: none; background: transparent; font-size: 1.6rem; cursor: pointer; color: #64748b;
          }
          .fournisseur-modal-body { padding: 1.25rem 1.5rem 1.5rem; }
          .achat-mini-table { width: 100%; border-collapse: collapse; }
          .achat-mini-table th, .achat-mini-table td {
            padding: 0.7rem 0.75rem; border-bottom: 1px solid #f1f5f9; text-align: left; font-size: 0.9rem;
          }
          .achat-mini-table th { color: #475569; text-transform: uppercase; font-size: 0.72rem; letter-spacing: 0.06em; }
          .detail-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
            gap: 0.85rem;
          }
          .detail-card {
            background: #f8fafc;
            border: 1px solid #e2e8f0;
            border-radius: 12px;
            padding: 0.85rem 1rem;
          }
          .detail-card span { display: block; font-size: 0.72rem; color: #64748b; text-transform: uppercase; font-weight: 700; margin-bottom: 0.25rem; }
          .detail-card strong { color: #1e293b; font-size: 0.98rem; }
        `}
      </style>

      <div className="fournisseurs-header">
        <h2 className="salarie-list-title">Liste des fournisseurs</h2>
        <Link to="/fournisseurs/add" className="add-btn">
          🏢 Ajouter Fournisseur
        </Link>
      </div>

      <div className="fournisseur-filters">
        <label>
          Nom du fournisseur
          <input
            name="name"
            value={filters.name}
            onChange={handleFilterChange}
            placeholder="Rechercher un nom…"
          />
        </label>
        <label>
          Nom du chantier
          <input
            name="chantier"
            value={filters.chantier}
            onChange={handleFilterChange}
            placeholder="Fournisseurs de ce chantier…"
          />
        </label>
        <label>
          N° Bon d'enlèvement
          <input
            name="numBonEnlevement"
            value={filters.numBonEnlevement}
            onChange={handleFilterChange}
            placeholder="Ex: BE-001"
          />
        </label>
        <label>
          Date d'achat
          <select name="filterType" value={filters.filterType} onChange={handleFilterChange}>
            <option value="all">Toutes les dates</option>
            <option value="day">Par jour</option>
            <option value="month">Par mois</option>
            <option value="year">Par année</option>
          </select>
        </label>
        {filters.filterType === "day" && (
          <label>
            Jour
            <input type="date" name="date" value={filters.date} onChange={handleFilterChange} />
          </label>
        )}
        {filters.filterType === "month" && (
          <label>
            Mois
            <select name="month" value={filters.month} onChange={handleFilterChange}>
              {MONTHS.map((m) => (
                <option key={m.value} value={m.value}>{m.label}</option>
              ))}
            </select>
          </label>
        )}
        {(filters.filterType === "month" || filters.filterType === "year") && (
          <label>
            Année
            <select name="year" value={filters.year} onChange={handleFilterChange}>
              {availableYears.map((y) => (
                <option key={y} value={y}>{y}</option>
              ))}
            </select>
          </label>
        )}
        <button type="button" className="filter-reset-btn" onClick={resetFilters}>
          Réinitialiser
        </button>
      </div>

      {loading ? (
        <div>Chargement...</div>
      ) : fournisseurs.length === 0 ? (
        <div className="empty-state">
          🏢 Aucun fournisseur trouvé.<br />
          <small>Modifiez les filtres ou ajoutez un fournisseur.</small>
        </div>
      ) : (
        <div className="fournisseurs-table-wrapper">
          <div className="fournisseurs-table-scroll">
            <table className="salarie-list-table">
              <thead>
                <tr>
                  <th>Nom du fournisseur</th>
                  <th>Budget (€)</th>
                  {dateFilterActive && <th>Montant période</th>}
                  <th>Achats</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {fournisseurs.map((f) => (
                  <tr key={f.id}>
                    <td data-label="Nom" className="fournisseur-name">
                      {f.name || "Nom non défini"}
                    </td>
                    <td data-label="Budget">
                      <span className="budget-badge">{formatMoney(f.budget)}</span>
                    </td>
                    {dateFilterActive && (
                      <td>{formatMoney(f.montantFiltre)}</td>
                    )}
                    <td>{f.matchingAchatsCount ?? f.achatsCount ?? 0}</td>
                    <td data-label="Actions">
                      <div className="actions-cell">
                        <button className="salarie-action-btn view" onClick={() => openView(f)}>
                          👁️ Voir
                        </button>
                        <button
                          className="salarie-action-btn edit"
                          onClick={() => navigate(`/fournisseurs/edit/${f.id}`)}
                        >
                          ✏️ Modifier
                        </button>
                        <button
                          className="salarie-action-btn delete"
                          onClick={() => handleDelete(f.id)}
                          disabled={deleteLoading === f.id}
                        >
                          {deleteLoading === f.id ? "⏳ Suppression..." : "🗑️ Supprimer"}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {viewLoading && (
        <div className="fournisseur-modal-overlay">
          <div className="fournisseur-modal small">
            <div className="fournisseur-modal-body">Chargement des achats…</div>
          </div>
        </div>
      )}

      {viewFournisseur && !selectedAchat && (
        <div className="fournisseur-modal-overlay" onClick={() => setViewFournisseur(null)}>
          <div className="fournisseur-modal" onClick={(e) => e.stopPropagation()}>
            <div className="fournisseur-modal-header">
              <div>
                <h3>{viewFournisseur.name}</h3>
                <div>Budget total : <strong>{formatMoney(viewFournisseur.budget)}</strong> — {viewFournisseur.achats?.length || 0} achat(s)</div>
              </div>
              <button className="fournisseur-modal-close" onClick={() => setViewFournisseur(null)}>×</button>
            </div>
            <div className="fournisseur-modal-body">
              {!viewFournisseur.achats?.length ? (
                <p style={{ color: "#64748b" }}>Aucun achat lié à ce fournisseur.</p>
              ) : (
                <table className="achat-mini-table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Chantier</th>
                      <th>N° Bon d'enlèvement</th>
                      <th>N° Nexxio</th>
                      <th>Montant</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {viewFournisseur.achats.map((achat) => (
                      <tr key={achat.id}>
                        <td>{formatDate(achat.date)}</td>
                        <td>{achat.chantierName || "—"}</td>
                        <td>{achat.numBonEnlevement || "—"}</td>
                        <td>{achat.numeroNexxio || "—"}</td>
                        <td>{formatMoney(achat.montantHT)}</td>
                        <td>
                          <button className="salarie-action-btn view" onClick={() => setSelectedAchat(achat)}>
                            Détails
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      )}

      {selectedAchat && (
        <div className="fournisseur-modal-overlay" onClick={() => setSelectedAchat(null)}>
          <div className="fournisseur-modal small" onClick={(e) => e.stopPropagation()}>
            <div className="fournisseur-modal-header">
              <div>
                <h3>Détail de l'achat</h3>
                <div>{viewFournisseur?.name}</div>
              </div>
              <button className="fournisseur-modal-close" onClick={() => setSelectedAchat(null)}>×</button>
            </div>
            <div className="fournisseur-modal-body">
              <div className="detail-grid">
                <div className="detail-card"><span>Date</span><strong>{formatDate(selectedAchat.date)}</strong></div>
                <div className="detail-card"><span>Chantier</span><strong>{selectedAchat.chantierName || "—"}</strong></div>
                <div className="detail-card"><span>Client</span><strong>{selectedAchat.client || "—"}</strong></div>
                <div className="detail-card"><span>Montant HT</span><strong>{formatMoney(selectedAchat.montantHT)}</strong></div>
                <div className="detail-card"><span>N° Bon d'enlèvement</span><strong>{selectedAchat.numBonEnlevement || "—"}</strong></div>
                <div className="detail-card"><span>N° Nexxio</span><strong>{selectedAchat.numeroNexxio || "—"}</strong></div>
                <div className="detail-card"><span>Type</span><strong>{selectedAchat.chargeName || "Achat"}</strong></div>
                <div className="detail-card"><span>Statut</span><strong>{selectedAchat.isReelle ? "Réelle" : "Provisoire"}</strong></div>
              </div>
              {selectedAchat.description ? (
                <div className="detail-card" style={{ marginTop: "1rem" }}>
                  <span>Description</span>
                  <strong>{selectedAchat.description}</strong>
                </div>
              ) : null}
              <div style={{ marginTop: "1.25rem", textAlign: "right" }}>
                <button className="salarie-action-btn edit" onClick={() => setSelectedAchat(null)}>
                  Retour aux achats
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Popup
        isOpen={deletePopup.isOpen}
        onClose={() => setDeletePopup({ isOpen: false, fournisseur: null })}
        onConfirm={confirmDelete}
        title="Confirmer la suppression"
        type="warning"
        showCancel={true}
      >
        <div className="delete-salarie-confirmation">
          <p>Êtes-vous sûr de vouloir supprimer ce fournisseur ?</p>
          {deletePopup.fournisseur && (
            <div className="salarie-info-popup">
              <div>
                <span className="popup-label">Nom :</span>{" "}
                <span className="popup-value">{deletePopup.fournisseur.name}</span>
              </div>
              <div>
                <span className="popup-label">Budget :</span>{" "}
                <span className="popup-value">{formatMoney(deletePopup.fournisseur.budget)}</span>
              </div>
            </div>
          )}
          <div className="popup-warning-text">⚠️ Cette action est irréversible !</div>
        </div>
      </Popup>
    </div>
  );
};

export default FournisseurList;
